// extracted by mini-css-extract-plugin
export default {"main":"not-found_main__OA915","link":"not-found_link__2QFrO"};